module.exports = __webpack_public_path__ + "static/img/newpertitle.ace4296.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newpertitle.png
// module id = TGaI
// module chunks = 1